import {
  DELETE_VEHICLE,
  DELETE_VEHICLE_FAILED,
  DELETE_VEHICLE_SUCCESS,
  EDIT_VEHICLE,
  EDIT_VEHICLE_FAILED,
  EDIT_VEHICLE_SUCCESS,
  FETCH_ALL_VEHICLES,
  FETCH_ALL_VEHICLES_FAILED,
  FETCH_ALL_VEHICLES_SUCCESS,
} from "../store/types";

import { cloud_function_server_url } from '../../config';

const END_POINT = `${cloud_function_server_url}/cars`;

export const fetchVehicles = () => (dispatch) => (firebase) => {

  dispatch({
    type: FETCH_ALL_VEHICLES,
    payload: null
  });

  fetch(`${END_POINT}/fetch-vehicles`, {
    method: 'GET',
  })
    .then(async (res) => {
      const response = await res.json();
      const data = response?.data;
      const arr = data.map(i => {
        const dataCopy = { ...i };
        dataCopy.id = i.uid;
        return dataCopy;
      });
      dispatch({
        type: FETCH_ALL_VEHICLES_SUCCESS,
        payload: arr
      });
    }).catch(error => {
      console.log("res check error", error);
      dispatch({
        type: FETCH_ALL_VEHICLES_FAILED,
        payload: "No users available."
      });
    });
};

export const addVehicle = (userdata) => (dispatch) => async (firebase) => {
  const {
    vehiclesRef,
    vehiclesDocsRef,
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_VEHICLE,
    payload: userdata
  });

  // let obj = {
  //   carType: userdata.carType
  // }
  // singleUserRef(userdata.driver).update(obj);

  // if (userdata.rcImage instanceof Blob) {
  //   let timestamp = new Date().getTime();
  //   await vehiclesDocsRef('rcbook', timestamp).put(userdata.rcImage);
  //   userdata.rcImage = await vehiclesDocsRef('rcbook', timestamp).getDownloadURL();
  // }
  // if (userdata.insuranceImage instanceof Blob) {
  //   let timestamp = new Date().getTime();
  //   await vehiclesDocsRef('insurance', timestamp).put(userdata.insuranceImage);
  //   userdata.insuranceImage = await vehiclesDocsRef('insurance', timestamp).getDownloadURL();
  // }
  // if (userdata.permitImage instanceof Blob) {
  //   let timestamp = new Date().getTime();
  //   await vehiclesDocsRef('permit', timestamp).put(userdata.permitImage);
  //   userdata.permitImage = await vehiclesDocsRef('permit', timestamp).getDownloadURL();
  // }
  // if (userdata.vehicleFront instanceof Blob) {
  //   let timestamp = new Date().getTime();
  //   await vehiclesDocsRef('front', timestamp).put(userdata.vehicleFront);
  //   userdata.vehicleFront = await vehiclesDocsRef('front', timestamp).getDownloadURL();
  // }
  // if (userdata.vehicleBack instanceof Blob) {
  //   let timestamp = new Date().getTime();
  //   await vehiclesDocsRef('back', timestamp).put(userdata.vehicleBack);
  //   userdata.vehicleBack = await vehiclesDocsRef('back', timestamp).getDownloadURL();
  // }
  // if (userdata.vehicleSide instanceof Blob) {
  //   let timestamp = new Date().getTime();
  //   await vehiclesDocsRef('side', timestamp).put(userdata.vehicleSide);
  //   userdata.vehicleSide = await vehiclesDocsRef('side', timestamp).getDownloadURL();
  // }

  fetch(`${END_POINT}/add-vehicle`, {
    method: 'POST',
    body: userdata
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("res check", response)
      dispatch({
        type: EDIT_VEHICLE_SUCCESS,
        payload: null
      });
      fetchVehicles()(dispatch)(firebase)
    }).catch(error => {
      console.log("res check error", error);
      dispatch({
        type: EDIT_VEHICLE_FAILED,
        payload: error
      });
    });
}

export const driverEditVehicle = (oldData, vehicle) => (dispatch) => async (firebase) => {

  const {
    singleVehicleRef,
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_VEHICLE,
    payload: vehicle
  });
  let driverObj = {
    driver: vehicle.driver
  }
  singleVehicleRef(oldData.id).update(driverObj).then(() => {
    let obj = {
      carType: vehicle.carType
    }
    singleUserRef(vehicle.driver).update(obj);
    dispatch({
      type: EDIT_VEHICLE_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: EDIT_VEHICLE_FAILED,
      payload: error
    });
  });
}

export const updateVehicleCommission = (oldData, vehicle) => (dispatch) => async (firebase) => {

  const {
    singleVehicleRef
  } = firebase;

  dispatch({
    type: EDIT_VEHICLE,
    payload: vehicle
  });
  let driverObj = {
    commission_fees: vehicle.commission_fees
  }
  singleVehicleRef(oldData.id).update(driverObj).then(() => {
    dispatch({
      type: EDIT_VEHICLE_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: EDIT_VEHICLE_FAILED,
      payload: error
    });
  });
}


export const editVehicle = (oldData, vehicle) => (dispatch) => async (firebase) => {

  console.log("oldData", oldData)

  const {
    singleVehicleRef,
    vehiclesDocsRef,
    imageStorageRef,
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_VEHICLE,
    payload: vehicle
  });
  // var rcImage = vehicle.rcImage ? vehicle.rcImage : '';
  // var insuranceImage = vehicle.insuranceImage ? vehicle.insuranceImage : '';
  // var permitImage = vehicle.permitImage ? vehicle.permitImage : '';
  // var vehicleFront = vehicle.vehicleFront ? vehicle.vehicleFront : '';
  // var vehicleBack = vehicle.vehicleBack ? vehicle.vehicleBack : '';
  // var vehicleSide = vehicle.vehicleSide ? vehicle.vehicleSide : vehicle.vehicleSide;

  // if (rcImage instanceof Blob) {
  //   if (oldData.rcImage) {
  //     imageStorageRef(oldData.rcImage).delete().then(async () => {
  //       let timestamp = new Date().getTime();
  //       await vehiclesDocsRef('rcbook', timestamp).put(vehicle.rcImage);
  //       vehicle.rcImage = await vehiclesDocsRef('rcbook', timestamp).getDownloadURL();
  //       uploadFile(oldData, vehicle, singleVehicleRef, dispatch)
  //     }).catch((error) => {
  //       console.log('error', error)
  //     });
  //   } else {
  //     let timestamp = new Date().getTime();
  //     await vehiclesDocsRef('rcbook', timestamp).put(vehicle.rcImage);
  //     vehicle.rcImage = await vehiclesDocsRef('rcbook', timestamp).getDownloadURL();
  //     uploadFile(oldData, vehicle, singleVehicleRef, dispatch)
  //   }
  // }
  // if (insuranceImage instanceof Blob) {
  //   if (oldData.insuranceImage) {
  //     imageStorageRef(oldData.insuranceImage).delete().then(async () => {
  //       let timestamp = new Date().getTime();
  //       await vehiclesDocsRef('insurance', timestamp).put(vehicle.insuranceImage);
  //       vehicle.insuranceImage = await vehiclesDocsRef('insurance', timestamp).getDownloadURL();
  //       uploadFile(oldData, vehicle, singleVehicleRef, dispatch)
  //     }).catch((error) => {
  //       console.log('error', error)
  //     });
  //   } else {
  //     let timestamp = new Date().getTime();
  //     await vehiclesDocsRef('insurance', timestamp).put(vehicle.insuranceImage);
  //     vehicle.insuranceImage = await vehiclesDocsRef('insurance', timestamp).getDownloadURL();
  //     uploadFile(oldData, vehicle, singleVehicleRef, dispatch)
  //   }
  // }
  // if (permitImage instanceof Blob) {
  //   if (oldData.permitImage) {
  //     imageStorageRef(oldData.permitImage).delete().then(async () => {
  //       let timestamp = new Date().getTime();
  //       await vehiclesDocsRef('permit', timestamp).put(vehicle.permitImage);
  //       vehicle.permitImage = await vehiclesDocsRef('permit', timestamp).getDownloadURL();
  //       uploadFile(oldData, vehicle, singleVehicleRef, dispatch)
  //     }).catch((error) => {
  //       console.log('error', error)
  //     });
  //   } else {
  //     let timestamp = new Date().getTime();
  //     await vehiclesDocsRef('permit', timestamp).put(vehicle.permitImage);
  //     vehicle.permitImage = await vehiclesDocsRef('permit', timestamp).getDownloadURL();
  //     uploadFile(oldData, vehicle, singleVehicleRef, dispatch)
  //   }
  // }

  // if (vehicleFront instanceof Blob) {
  //   if (oldData.vehicleFront) {
  //     imageStorageRef(oldData.vehicleFront).delete().then(async () => {
  //       let timestamp = new Date().getTime();
  //       await vehiclesDocsRef('front', timestamp).put(vehicle.vehicleFront);
  //       vehicle.vehicleFront = await vehiclesDocsRef('front', timestamp).getDownloadURL();
  //       uploadFile(oldData, vehicle, singleVehicleRef, dispatch)
  //     }).catch((error) => {
  //       console.log('error', error)
  //     });
  //   } else {
  //     let timestamp = new Date().getTime();
  //     await vehiclesDocsRef('front', timestamp).put(vehicle.vehicleFront);
  //     vehicle.vehicleFront = await vehiclesDocsRef('front', timestamp).getDownloadURL();
  //     uploadFile(oldData, vehicle, singleVehicleRef, dispatch)
  //   }
  // }

  // if (vehicleBack instanceof Blob) {
  //   if (oldData.vehicleBack) {
  //     imageStorageRef(oldData.vehicleBack).delete().then(async () => {
  //       let timestamp = new Date().getTime();
  //       await vehiclesDocsRef('back', timestamp).put(vehicle.vehicleBack);
  //       vehicle.vehicleBack = await vehiclesDocsRef('back', timestamp).getDownloadURL();
  //       uploadFile(oldData, vehicle, singleVehicleRef, dispatch)
  //     }).catch((error) => {
  //       console.log('error', error)
  //     });
  //   } else {
  //     let timestamp = new Date().getTime();
  //     await vehiclesDocsRef('back', timestamp).put(vehicle.vehicleBack);
  //     vehicle.vehicleBack = await vehiclesDocsRef('back', timestamp).getDownloadURL();
  //     uploadFile(oldData, vehicle, singleVehicleRef, dispatch)
  //   }
  // }

  // if (vehicleSide instanceof Blob) {
  //   if (oldData.vehicleSide) {
  //     imageStorageRef(oldData.vehicleSide).delete().then(async () => {
  //       let timestamp = new Date().getTime();
  //       await vehiclesDocsRef('side', timestamp).put(vehicle.vehicleSide);
  //       vehicle.vehicleSide = await vehiclesDocsRef('side', timestamp).getDownloadURL();
  //       uploadFile(oldData, vehicle, singleVehicleRef, dispatch)
  //     }).catch((error) => {
  //       console.log('error', error)
  //     });
  //   } else {
  //     let timestamp = new Date().getTime();
  //     await vehiclesDocsRef('side', timestamp).put(vehicle.vehicleSide);
  //     vehicle.vehicleSide = await vehiclesDocsRef('side', timestamp).getDownloadURL();
  //     uploadFile(oldData, vehicle, singleVehicleRef, dispatch)
  //   }
  // }

  fetch(`${END_POINT}/edit-vehicle/${oldData.id}`, {
    method: 'PUT',
    body: vehicle
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("response", response)
      dispatch({
        type: EDIT_VEHICLE_SUCCESS,
        payload: null
      });
      fetchVehicles()(dispatch)(firebase)
    }).catch(error => {
      console.log("res check error", error)
      dispatch({
        type: EDIT_VEHICLE_FAILED,
        payload: error
      });
    });

  // if (rcImage instanceof Blob === false &&
  //   insuranceImage instanceof Blob === false &&
  //   permitImage instanceof Blob === false &&
  //   vehicleFront instanceof Blob === false &&
  //   vehicleBack instanceof Blob === false &&
  //   vehicleSide instanceof Blob === false) {
  //   let editedVehicle = vehicle;
  //   delete editedVehicle.id;
  //   let oldDriverObj = {
  //     carType: ""
  //   }
  //   singleUserRef(oldData.driver).update(oldDriverObj);
  //   singleVehicleRef(oldData.id).set(editedVehicle).then(() => {
  //     let obj = {
  //       carType: vehicle.carType
  //     }
  //     singleUserRef(vehicle.driver).update(obj);
  //     dispatch({
  //       type: EDIT_VEHICLE_SUCCESS,
  //       payload: null
  //     });
  //   }).catch((error) => {
  //     dispatch({
  //       type: EDIT_VEHICLE_FAILED,
  //       payload: error
  //     });
  //   });
  // }
}

const uploadFile = (oldData, vehicle, singleVehicleRef, dispatch) => {
  let editedVehicle = vehicle;
  delete editedVehicle.id;
  singleVehicleRef(oldData.id).set(editedVehicle).then(() => {
    dispatch({
      type: EDIT_VEHICLE_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: EDIT_VEHICLE_FAILED,
      payload: error
    });
  });
}

export const deleteVehicle = (id, driverId) => (dispatch) => (firebase) => {

  // const {
  //   singleVehicleRef,
  //   singleUserRef
  // } = firebase;

  dispatch({
    type: DELETE_VEHICLE,
    payload: id
  });

  // let oldDriverObj = {
  //   carType: ""
  // }
  // singleUserRef(driverId).update(oldDriverObj);

  fetch(`${END_POINT}/delete-vehicle/${id}?driver=${driverId}`, {
    method: 'DELETE',
  })
    .then(async (res) => {
      const response = await res.json();
      console.log("response", response)
      dispatch({
        type: DELETE_VEHICLE_SUCCESS,
        payload: null
      });
      fetchVehicles()(dispatch)(firebase)
    }).catch(error => {
      console.log("res check error", error)
      dispatch({
        type: DELETE_VEHICLE_FAILED,
        payload: error
      });
    });

  // singleVehicleRef(id).remove().then(() => {
  //   dispatch({
  //     type: DELETE_VEHICLE_SUCCESS,
  //     payload: null
  //   });
  // }).catch((error) => {
  //   dispatch({
  //     type: DELETE_VEHICLE_FAILED,
  //     payload: error
  //   });
  // });
}